import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { locale } = useRouter();
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const [isEnter, setIsEnter] = useState(false);
    const { t } = useLang('ecoflowpowerkitsseries');

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitA',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0.4, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: layoutH, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', function () {
            setIsEnter(true);
        });
        AniContainer.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.kitA} kitA`}>
            <div className="img-content">
                {locale === 'au' ? (
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1722827982250/efmm100bg_au_pc.jpg" alt={t('presale.product.kitA_title1')} />
                ) : (
                    <EFPic name={['efmm100bg.webp', 'efmm100bg.jpg']} className="fullImgs" alt="" />
                )}
            </div>
            <div className={`v-msg ${isEnter ? 'isEnter' : ''}`}>
                <div className="v-msg-title1">{t('presale.product.kitA_title1')}</div>
                <div className="v-msg-title2">{t('presale.product.kitA_title2')}</div>
            </div>
        </div>
    );
}
